import {InitPositionsAction, PositionsAction, PositionType} from "../state/positions";
import {fork, put, select, takeEvery} from "redux-saga/effects";
import {Storage, ToStorage,} from "./storage";
import {PositionAction} from "../state/position";
import {RootState} from "../../Store";
import { slugifyPath} from "../../../utils/slugifyPath";
import { AppState} from "../state";
import { StatusAction} from "../state/status";
import {slugifyParse} from "./slugifyParse";
import { ContextAction } from "../state/context";
import type { QueryClient } from '@tanstack/react-query'
import {updatePodcastEpisodeListenedTime} from "../../../queriesKeys/usePodcastEpisodeListenedTime";

export function* positions() {

    const createUrl = (id: number, duration: number )=> `${process.env.REACT_APP_API_DOMAIN}/api/v1/user/liked/episodes/${id}?duration=${duration}`;
    const savedPositions: { [url: number]: number } = {};
    const lastSavedTime: { [url: number]: number } = {};
    let queryClient:QueryClient|null|undefined = undefined;

    const sendBeacon = (id: number, duration: number, ending: boolean) => {

        if (!(id in savedPositions)
            || savedPositions[id] !== duration)
        {
            if (ending
                || lastSavedTime[id] === undefined
                || Math.abs(lastSavedTime[id] - duration) >= 300) {
                savedPositions[id] = duration;
                lastSavedTime[id] = duration;
                navigator.sendBeacon(createUrl(id, duration));
                if (queryClient) {
                    updatePodcastEpisodeListenedTime(id, duration, queryClient)
                }
            }
        }
    }



    let saved:{ [path:string]: (ending?: boolean)=>void} = {}

    const filter = (ingoreItem?: string, ending?: boolean)=> {
        Object.keys(saved).forEach(i=>{
            if (ingoreItem !== i) {
                const p = saved[i];
                p(ending);
                delete saved[i];
            }
        });
    }
    if (typeof window !== "undefined")
        window.addEventListener("beforeunload", ()=>filter(undefined, true));

    yield takeEvery<ContextAction>("Context", function * (action) {
        queryClient = action.payload.queryClient;
        yield
    });

    yield takeEvery<StatusAction>("Status", function * (action) {
        if (action.payload === "STOPPED") {
            yield  filter(undefined, true);
        }
    });

    yield takeEvery<PositionAction>("Position", function * (action) {
        const item:  PlayedItemType|null = yield select((state: RootState)=> state.playedItem);
        if (item && "programSlug" in item) {
            const savedPath = slugifyPath(item, true);
            yield put<PositionsAction>({
                type: "Positions",
                payload: {
                    slug: savedPath,
                    time: action.payload,
                    save: true
                }
            })
            const curUser:boolean = yield select((x:RootState) => x.currentUser);
            if (curUser) {
                delete saved[savedPath];
                sendBeacon(item.id, action.payload, true);
            }
        }
    });

    yield takeEvery<PositionsAction>("Positions",  function * (action) {

        const slug = action.payload.slug;
        const parsed = slugifyParse(action.payload.slug);

        filter(slug, false);

        if ("programSlug" in parsed) {
            sendBeacon(parsed.id, action.payload.time, action.payload.save);
        }

        saved[slug] = (ending?: boolean) => {
            if ("programSlug" in parsed) {
                sendBeacon(parsed.id, action.payload.time, !!ending);
            }
        };

        const positions: PositionType[] = yield select((app: AppState)=> app.positions);
        ToStorage("rczpos", positions);
    });

    yield fork(Storage, "rczpos", function * (value: any) {
        if (value) {
            const v = value;
            if (Array.isArray(v)) {
                const data = v.map(x => {
                    const time = parseFloat(x.time);
                    const slug = x.slug;
                    if (time && slug)
                        return {
                            slug,
                            time
                        }
                    return null;
                }).filter(x => !!x);
                yield put<InitPositionsAction>({
                    type: "InitPositions",
                    payload: data as any
                });
            }
        }
    });
}